import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

// Define an async thunk to fetch data from the API
let abortController;
export const fetchUserData = createAsyncThunk(
  "auth/fetchUserData",
  async ({ page, page_size, searchQuery, role, is_active }, { rejectWithValue }) => {
    try {

      if(abortController){
        abortController.abort();
      }

      abortController = new AbortController();
      
      const response = await axiosInstance.get("/auth/user_management/", {
        params: {
          page: page,
          page_size: page_size,
          search: searchQuery,
          role: role,
          is_active: is_active,
        },
        signal: abortController.signal,
      });
      return response.data;
    } catch (error) {
      // Ignore canceled requests
      if (error.code === "ERR_CANCELED") {
        return rejectWithValue("Request cancelled");
      }

      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateUserStatus = createAsyncThunk(
  "auth/updateUserStatus",
  async (data, { rejectWithValue }) => {
    try {
      // Ensure the payload is in JSON format
      const response = await axiosInstance.put(`/auth/user_management/`, JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json", // Explicitly set the header
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const fetchUserCommunityData = createAsyncThunk(
  "auth/fetchUserCommunityData",
  async ({ id, page, pageSize }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/community/claimed-community/${id}`, {
        params: {
          page: page,
          page_size: pageSize,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchUserProfile = createAsyncThunk(
  "userprofile",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/auth/${id}/`);
      return response.data;
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);

export const unassignAssociationManager = createAsyncThunk(
  "community/unassignAssociationManager",
  async ({ community_id, manager_id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.delete(
        "/community/change-association-manager/",
        {
          // DELETE with body: send payload under `data`
          data: { community_id, manager_id },
        }
      );
      return data; // e.g. { community_id, manager_id: null, ... }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data ?? error.message
      );
    }
  }
);